import { Button } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { containerCSS } from "./AssignSetupClassesWarning.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

type AssignSetupClassesWarningProps = {
  onClickGoToClassDirectory: () => Promise<void>;
};

const AssignSetupClassesWarning = ({
  onClickGoToClassDirectory,
}: AssignSetupClassesWarningProps) => {
  return (
    <div css={containerCSS}>
      <span>
        Oops, looks like you don’t have any classes set up. Please set up
        classes in your class directory to create assignments.
      </span>
      <ButtonWithTrackEvent
        onClick={onClickGoToClassDirectory}
        flavor={Button.flavors.polarPrimary}
        size={Button.sizes.md}
        objectType={objectTypes.user}
        actionName={actionNames.interact}
        dataProps={{
          "data-qa-selector": "assignment_builder_class_sync_redirect",
        }}
      >
        Go to class directory
      </ButtonWithTrackEvent>
    </div>
  );
};
export default AssignSetupClassesWarning;
